import { tl } from '../../i18n/t';
import type { LohnKind } from './types';

// Bezeichnungen bleiben Deutsch (tl); übersetzt wird beim Anzeigen mit t()
export const LOHN_KINDS: { key: LohnKind; label: string }[] = [
  { key: 'abrechnungen', label: tl('Lohnabrechnungen') },
  { key: 'zahlungsliste', label: tl('Zahlungsliste') },
  { key: 'beitragsnachweise', label: tl('Beitragsnachweise') },
  { key: 'lst_anmeldung', label: tl('Lohnsteuer-Anmeldung') },
  { key: 'lst_freigabe', label: tl('Lohnsteuer-Anmeldung zur Freigabe') },
  { key: 'lohnjournal', label: tl('Lohnjournal') },
  { key: 'buchungsliste', label: tl('Buchungsliste') },
  { key: 'sonstige', label: tl('Weitere Lohnunterlagen') },
];
export const LOHN_KIND_LABEL = Object.fromEntries(LOHN_KINDS.map((k) => [k.key, k.label])) as Record<LohnKind, string>;

// Pfade: /app/mitarbeiter/<Firma>, …/neu, …/lohn/<Jahr>/<Monat>
export const lohnPath = (clientId?: string) => (clientId ? `/app/mitarbeiter/${clientId}` : '/app/mitarbeiter');
export const newEmployeePath = (clientId: string) => `${lohnPath(clientId)}/neu`;
export const lohnMonthPath = (clientId: string, year: number, month: number) => `${lohnPath(clientId)}/lohn/${year}/${month}`;
